import { Instagram, Phone, Mail } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import logo from "@/assets/logo-fd.png";
import bfcLogo from "@/assets/bfc-logo.jpg";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-espresso text-cream py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="Federico Duronio" className="h-12 w-12 object-contain" />
              <span className="font-bold text-lg">Federico Duronio</span>
            </div>
            <p className="text-cream/80 text-sm">{t("footer", "tagline")}</p>
          </div>

          <div>
            <h4 className="font-bold mb-4">{t("footer", "servicios")}</h4>
            <ul className="space-y-2 text-sm text-cream/80">
              <li><a href="#cursos" className="hover:text-gold transition-colors">{t("footer", "cursosCafe")}</a></li>
              <li><a href="#servicios" className="hover:text-gold transition-colors">{t("footer", "consultoria")}</a></li>
              <li><a href="#maquinas-bfc" className="hover:text-gold transition-colors">{t("footer", "maquinasBfc")}</a></li>
              <li><a href="#sobre-mi" className="hover:text-gold transition-colors">{t("footer", "sobreMi")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">{t("footer", "cursosTitle")}</h4>
            <ul className="space-y-2 text-sm text-cream/80">
              <li>{t("footer", "cursoBarista")}</li>
              <li>{t("footer", "cursoLatteArt")}</li>
              <li>{t("footer", "cursoPersonalizado")}</li>
              <li>{t("footer", "formacionContinua")}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">{t("footer", "contacto")}</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:+34606649183" className="flex items-center gap-2 text-cream/80 hover:text-gold transition-colors">
                  <Phone className="w-4 h-4" />
                  +34 606 649 183
                </a>
              </li>
              <li>
                <a href="mailto:federicoduronio@gmail.com" className="flex items-center gap-2 text-cream/80 hover:text-gold transition-colors">
                  <Mail className="w-4 h-4" />
                  federicoduronio@gmail.com
                </a>
              </li>
              <li>
                <a href="https://instagram.com/federicoduronio" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-cream/80 hover:text-gold transition-colors">
                  <Instagram className="w-4 h-4" />
                  @federicoduronio
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cream/20 pt-8 pb-8">
          <h4 className="font-bold mb-6 text-center">{t("footer", "partners")}</h4>
          <div className="flex justify-center items-center gap-8 flex-wrap">
            <img src={bfcLogo} alt="BFC Coffee Machines España" className="h-16 object-contain opacity-80 hover:opacity-100 transition-opacity" />
          </div>
        </div>

        <div className="border-t border-cream/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-cream/60">{t("footer", "derechos")}</p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-cream/60 hover:text-gold transition-colors">{t("footer", "privacidad")}</a>
            <a href="#" className="text-sm text-cream/60 hover:text-gold transition-colors">{t("footer", "terminos")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
